const InitiateMockIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
      <path
        d="M13.6654 2.45331L6.0587 10.0666L3.23203 7.23998L4.17203 6.29998L6.0587 8.18665L12.7254 1.51998L13.6654 2.45331ZM6.9987 12.3333C4.0587 12.3333 1.66536 9.93998 1.66536 6.99998C1.66536 4.05998 4.0587 1.66665 6.9987 1.66665C8.04536 1.66665 9.02536 1.97331 9.85203 2.49998L10.8187 1.53331C9.73203 0.77998 8.4187 0.333313 6.9987 0.333313C3.3187 0.333313 0.332031 3.31998 0.332031 6.99998C0.332031 10.68 3.3187 13.6666 6.9987 13.6666C8.15203 13.6666 9.2387 13.3733 10.1854 12.8533L9.18536 11.8533C8.5187 12.16 7.7787 12.3333 6.9987 12.3333ZM11.6654 8.99998H9.66537V10.3333H11.6654V12.3333H12.9987V10.3333H14.9987V8.99998H12.9987V6.99998H11.6654V8.99998Z"
        fill="#585757"
      />
    </svg>
  );
};

export default InitiateMockIcon;
